<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view v-if="IsRouterAlive"></router-view>
    </transition>
  </div>
</template>

<script>
import "../src/assets/iconfont/iconfont.css";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      IsRouterAlive: true
    };
  },
  created() {},
  watch: {},
  methods: {
    reload() {
      this.$$nextTick(function() {
        this.IsRouterAlive = true;
      });
    }
  }
};
</script>
<style>
body {
  font-size: 14px;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
  -webkit-font-smoothing: antialiased;
  min-height: 100%;
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: 100%;
  /* 全站唯一未接主题的底：过路由/滚动切换时避免闪白 */
  background: var(--app-bg-solid);
}
html {
  width: 100%;
  height: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
#app {
  width: 100%;
  height: 100%;
}
</style>
